import { createAction } from 'redux-act';
// create update mrf action
const getAllLocationsRequest = createAction('GET_ALL_LOCATIONS_REQUEST', data => data);
const getAllLocationsSuccess = createAction('GET_ALL_LOCATIONS_SUCCESS', data => data);
const getAllLocationsError = createAction('GET_ALL_LOCATIONS_ERROR');

const createLocationRequest = createAction('CREATE_LOCATIONS_REQUEST', data => data);
const createLocationSuccess = createAction('CREATE_LOCATIONS_SUCCESS', data => data);
const createLocationError = createAction('CREATE_LOCATIONS_ERROR');

const updateLocationRequest = createAction('UPDATE_LOCATIONS_REQUEST', data => data);
const updateLocationSuccess = createAction('UPDATE_LOCATIONS_SUCCESS', data => data);
const updateLocationError = createAction('UPDATE_LOCATIONS_ERROR');

const deleteLocationRequest = createAction('DELETE_LOCATIONS_REQUEST', data => data);
const deleteLocationSuccess = createAction('DELETE_LOCATIONS_SUCCESS', data => data);
const deleteLocationError = createAction('DELETE_LOCATIONS_ERROR');

const getAllLocationsDataRequest = createAction('GET_ALL_LOCATIONS_DATA_REQUEST', data => data);
const getAllLocationsDataSuccess = createAction('GET_ALL_LOCATIONS_DATA_SUCCESS', data => data);
const getAllLocationsDataError = createAction('GET_ALL_LOCATIONS_DATA_ERROR');

const getAllCountriesListRequest = createAction('GET_ALL_COUNTRIES_LIST_REQUEST', data => data);
const getAllCountriesListSuccess = createAction('GET_ALL_COUNTRIES_LIST_SUCCESS', data => data);
const getAllCountriesListError = createAction('GET_ALL_COUNTRIES_LIST_ERROR');

const getAllStateFromCountryListRequest = createAction('GET_ALL_STATE_FROM_COUNTRIES_LIST_REQUEST', data => data);
const getAllStateFromCountryListSuccess = createAction('GET_ALL_STATE_FROM_COUNTRIES_LIST_SUCCESS', data => data);
const getAllStateFromCountryListError = createAction('GET_ALL_STATE_FROM_COUNTRIES_LIST_ERROR');

const getCityListFromStateRequest = createAction('GET_ALL_CITY_LIST_FROM_STATE_REQUEST', data => data);
const getCityListFromStateSuccess = createAction('GET_ALL_CITY_LIST_FROM_STATE_SUCCESS', data => data);
const getCityListFromStateError = createAction('GET_ALL_CITY_LIST_FROM_STATE_ERROR');

const addEmployeeLocationRequest = createAction('ADD_EMPLOYEE_LOCATION_REQUEST', data => data);
const addEmployeeLocationSuccess = createAction('ADD_EMPLOYEE_LOCATION_SUCCESS', data => data);
const addEmployeeLocationError = createAction('ADD_EMPLOYEE_LOCATION_ERROR');

const getEmployeeLocationRequest = createAction('GET_EMPLOYEE_LOCATION_REQUEST', data => data);
const getEmployeeLocationSuccess = createAction('GET_EMPLOYEE_LOCATION_SUCCESS', data => data);
const getEmployeeLocationError = createAction('GET_EMPLOYEE_LOCATION_ERROR');

const updateMultipleEmployeeLocationRequest = createAction('UPDATE_MULTIPLE_EMPLOYEE_LOCATION_REQUEST', data => data);
const updateMultipleEmployeeLocationSuccess = createAction('UPDATE_MULTIPLE_EMPLOYEE_LOCATION_SUCCESS', data => data);
const updateMultipleEmployeeLocationError = createAction('UPDATE_MULTIPLE_EMPLOYEE_LOCATION_ERROR');

const getAllCityRequest = createAction('GET_ALL_CITY_REQUEST', data => data);
const getAllCitySuccess = createAction('GET_ALL_CITY_SUCCESS', data => data);
const getAllCityError = createAction('GET_ALL_CITY_ERROR');

const getAllCityFromCountryRequest = createAction('GET_ALL_CITY_FROM_COUNTRY_REQUEST', data => data);
const getAllCityFromCountrySuccess = createAction('GET_ALL_CITY_FROM_COUNTRY_SUCCESS', data => data);
const getAllCityFromCountryError = createAction('GET_ALL_CITY_FROM_COUNTRY_ERROR');

const getLocationByLetLogRequest = createAction('GET_LOCATION_BY_LAT_LOG_REQUEST', data => data);
const getLocationByLetLogSuccess = createAction('GET_LOCATION_BY_LAT_LOG_SUCCESS', data => data);
const getLocationByLetLogError = createAction('GET_LOCATION_BY_LAT_LOG_ERROR');

// clear existing Department action
const handleClearLocationStore = createAction('HANDLE_CLEAR_LOCATION_STORE', data => data);


export default {
    getAllLocationsRequest,
    getAllLocationsSuccess,
    getAllLocationsError,

    createLocationRequest,
    createLocationSuccess,
    createLocationError,

    updateLocationRequest,
    updateLocationSuccess,
    updateLocationError,

    deleteLocationRequest,
    deleteLocationSuccess,
    deleteLocationError,

    getAllLocationsDataRequest,
    getAllLocationsDataSuccess,
    getAllLocationsDataError,

    getAllCountriesListRequest,
    getAllCountriesListSuccess,
    getAllCountriesListError,

    getAllStateFromCountryListRequest,
    getAllStateFromCountryListSuccess,
    getAllStateFromCountryListError,

    getCityListFromStateRequest,
    getCityListFromStateSuccess,
    getCityListFromStateError,

    addEmployeeLocationRequest,
    addEmployeeLocationSuccess,
    addEmployeeLocationError,

    getEmployeeLocationRequest,
    getEmployeeLocationSuccess,
    getEmployeeLocationError,

    updateMultipleEmployeeLocationRequest,
    updateMultipleEmployeeLocationSuccess,
    updateMultipleEmployeeLocationError,

    getAllCityRequest,
    getAllCitySuccess,
    getAllCityError,

    getAllCityFromCountryRequest,
    getAllCityFromCountrySuccess,
    getAllCityFromCountryError,

    getLocationByLetLogRequest,
    getLocationByLetLogSuccess,
    getLocationByLetLogError,

    handleClearLocationStore,

}